import { TableView, TableViewColumn } from '@/design-system/components/table/TableView';
import { H6, TextBody } from '@/design-system/components/typography';
import { PageContainer } from '@/features/earn/components/page/PageContainer';
import { PageItem } from '@/features/earn/components/page/PageItem';
import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import React from 'react';
import { DevToolsPageHeader } from '../components/DevToolsPageHeader';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';

export const DevToolsTable: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Table>> = ({ navigation }) => {
  const tableData: Array<{ id: number; name: string; age: number }> = [
    { id: 1, name: 'John', age: 20 },
    { id: 2, name: 'Jane', age: 21 },
    { id: 3, name: 'Jack', age: 22 },
    { id: 4, name: 'Jill', age: 23 },
    { id: 5, name: 'Jenny', age: 24 }
  ];

  const tableColumns: TableViewColumn<{ id: number; name: string; age: number }> = [
    {
      index: 'id',
      title: 'Id'
    },
    {
      index: 'name',
      title: 'Name'
    },
    {
      index: 'age',
      title: 'Age',
      render: (item) => <H6 bold>{item.age}</H6>
    },
    {
      index: 'id',
      title: 'Date of Birth',
      formatValue: (item) => new Date().toISOString()
    }
  ];

  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <DevToolsPageHeader currentPage={DevToolsStackRoutes.Table} />
          {/* <Divider /> */}
          <View sx={{ flex: 1, flexDirection: 'row', gap: '$5', width: '100%' }}>
            <PageItem sx={styles.pageItem}>
              <H6 bold>TableView</H6>
              <TableView data={tableData} columns={tableColumns} rowVerticalAlign="center" />
              <PageItem sx={styles.pageItem}>
                <H6 bold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
const tableData: Array<{ id: number; name: string; age: number }> = [
  { id: 1, name: 'John', age: 20 },
  { id: 2, name: 'Jane', age: 21 },
  { id: 3, name: 'Jack', age: 22 },
  { id: 4, name: 'Jill', age: 23 },
  { id: 5, name: 'Jenny', age: 24 }
];

const tableColumns: TableViewColumn<{ id: number; name: string; age: number }> = [
  {
    index: 'id',
    title: 'Id'
  },
  {
    index: 'name',
    title: 'Name'
  },
  {
    index: 'age',
    title: 'Age',
    render: (item) => <H6 bold>{item.age}</H6>
  },
  {
    index: 'id',
    title: 'Date of Birth',
    formatValue: (item) => new Date().toISOString()
  }
];

<TableView data={tableData} columns={tableColumns} rowVerticalAlign="center"/>
`}
                </TextBody>
              </PageItem>
            </PageItem>
          </View>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1
  },
  pageItem: {
    flex: 1,
    padding: '$7',
    borderRadius: 10,
    gap: '$8'
  }
};
